<template>
    <div class="relative">

        <list-skeleton :rows="rows"></list-skeleton>

        <div
            class="empty-state-container"
            :class="{ 'hidden-xs': !showMobile }"
            style="top:10px;"
        >
            <div class="empty-state-text">
                <div>
                    <i :class="icon"></i>
                    <h3>{{ title }}</h3>

                    <slot name="content" />
                </div>
            </div>
            <div class="container container-dark container-sm"></div>
            <div class="container container-grey container-md container-top"></div>
            <div class="container container-grey container-sm container-bottom"></div>
        </div>
    </div>
</template>

<script>
import ListSkeleton from 'App/components/global/ListSkeleton.vue'

export default {
    components: {
        ListSkeleton,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        showMobile: {
            type: Boolean,
            required: false,
            default: false,
        },
        rows: {
            type: Number,
            required: false,
            default: 5,
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'Sass/system/global/variables';
.empty-state-container {
    position: absolute;
    top: -50px;
    left: -5px;
    display: flex;
    justify-content: center;
    width: calc(100% + 10px);
    opacity: 0;
    animation: fade-in .5s linear forwards;
    animation-delay: 1.5s;
    overflow-x: hidden;


    @media (max-width: $screen-xs-max) {
        top: -20px;
    }

    .empty-state-text {
        display: flex;
        align-items: center;
        padding: 50px 60px 75px 60px;
        background-color: var(--primary-color);
        width: 420px;
        min-width: 420px;
        height: 420px;
        color: white;
        text-align: center;
        border-radius: 50%;
        z-index: 100;
        margin: 20px 0;

        i {
            font-size: 50px;
            margin-bottom: 15px;
        }

        h3 {
            color: white;
            margin: 0 0 30px 0;
        }
    }

    .container {
        position: absolute;
        border-radius: 50%;
        z-index: 20;

        &.container-grey {
            background-color: #CCD3D8;

            &.container-bottom {
                transform: translate(10px, 160px);
            }

            &.container-top {
                transform: translate(-55px, 15px);
            }
        }

        &.container-dark {
            background-color: #444444;
            transform: translate(-70px, 150px);
        }

        &.container-md {
            width: 350px;
            height: 350px;
        }

        &.container-sm {
            width: 300px;
            height: 300px;
        }
    }
}
</style>
